<template>
  <div>
    <h2>检测员管理</h2>

    <!-- 查询条件 -->
    <el-row gutter="20" class="search-bar">
      <el-col :span="8">
        <el-input
            v-model="searchParams.nickName"
            placeholder="请输入昵称"
            clearable
        ></el-input>
      </el-col>
      <el-col :span="8">
        <el-input
            v-model="searchParams.phone"
            placeholder="请输入手机号"
            clearable
        ></el-input>
      </el-col>
      <el-col :span="8">
        <!-- 超级管理员可以指定 AdminId -->
        <el-input
            v-if="permission === 0"
            v-model="searchParams.adminId"
            type="number"
            placeholder="请输入AdminId"
            clearable
        ></el-input>
      </el-col>
    </el-row>

    <div class="button-group">
      <el-button type="primary" @click="searchInspectors">查询检测员</el-button>
      <el-button type="success" @click="showCreateDialog">新增检测员</el-button>
    </div>

    <!-- 检测员列表 -->
    <el-table
        :data="inspectors"
        border
        style="width: 100%; margin-top: 20px"
    >
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="nickName" label="昵称" width="120" />
      <el-table-column prop="phone" label="手机号" width="150" />
      <el-table-column prop="permission" label="权限" width="100">
        <template v-slot="scope">
          <span>{{ scope.row.permission === 0 ? '超级管理员' : scope.row.permission === 1 ? '管理员' : '检测员' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="adminId" label="Admin ID" width="120" />
      <el-table-column prop="createTime" label="创建时间" width="180" />
      <el-table-column prop="updateTime" label="更新时间" width="180" />
      <el-table-column label="操作" width="150">
        <template v-slot="scope">
          <div style="display: flex; gap: 10px; justify-content: center;">
            <el-button
                size="mini"
                @click="showEditDialog(scope.row)"
            >
              编辑
            </el-button>
            <el-button
                size="mini"
                type="danger"
                @click="confirmDelete(scope.row.id)"
            >
              删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageParams.current"
          :page-size="pageParams.pageSize"
          :total="pageParams.total"
          layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog
        :title="dialogMode === 'create' ? '新增检测员' : '编辑检测员'"
        v-model="dialogVisible"
    >
      <el-form :model="formData" :rules="rules" ref="formRef">
        <el-form-item label="昵称" required>
          <el-input v-model="formData.nickName" placeholder="请输入昵称"/>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" required>
          <el-input v-model="formData.phone" placeholder="请输入手机号"
                    :disabled="dialogMode === 'edit'" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="formData.password" placeholder="请输入密码" />
        </el-form-item>
        <el-form-item label="确认密码" prop="rePassword">
          <el-input type="password" v-model="formData.rePassword" placeholder="请再次输入密码" />
        </el-form-item>
        <el-form-item label="权限" required>
          <el-select v-model="formData.permission" placeholder="请选择权限">
            <el-option label="检测员" :value="2"></el-option>
            <el-option label="管理员" :value="1" v-if="permission === 0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Admin ID" v-if="dialogMode === 'create' && permission === 0">
          <el-input v-model="formData.adminId" placeholder="请输入 Admin ID（仅超级管理员可设置）" />
        </el-form-item>
        <!-- 新增 adminPhone 字段 -->
        <el-form-item label="管理员手机号" prop="adminPhone" v-if="permission === 0 && dialogMode === 'edit'">
          <el-input v-model="formData.adminPhone" placeholder="请输入所属管理员手机号" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchInspectors,
  deleteInspector,
  createInspector,
  updateInspector,
} from "@/api/inspector";

export default {
  data() {
    return {
      inspectors: [],
      searchParams: {
        adminId: null,
        nickName: "",
        phone: "",
      },
      pageParams: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      permission: null, // 用户权限
      dialogMode: "create", // 对话框模式：create 或 edit
      dialogVisible: false, // 对话框显示状态
      formData: {
        id: null,
        nickName: "",
        phone: "",
        password: "",
        rePassword: "",
        permission: 2,
        adminId: null, // Admin ID
        adminPhone: "", // 所属管理员手机号
      },
      rules: {
        password: [
          { min: 8, message: "密码至少8位", trigger: "blur" }, // 校验密码长度
        ],
        rePassword: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.password && value !== this.formData.password) {
                callback(new Error("两次密码输入不一致"));
              } else {
                callback(); // 校验通过
              }
            },
            trigger: "blur",
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        adminPhone: [
          { required: false }, // 超级管理员的 `adminPhone` 是可选的
          { pattern: /^1[3-9]\d{9}$/, message: "管理员手机号格式不正确", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 当每页大小改变时触发的事件
    handleSizeChange(size) {
      this.pageParams.pageSize = size; // 更新每页大小
      this.pageParams.current = 1; // 重置为第一页
      this.searchInspectors(); // 重新加载数据
    },

    // 当当前页改变时触发的事件
    handleCurrentChange(page) {
      this.pageParams.current = page; // 更新当前页
      this.searchInspectors(); // 重新加载数据
    },
    // 删除确认框
    async confirmDelete(id) {
      this.$confirm('确定要删除该检测员吗？', '确认删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            // 确认删除
            this.deleteInspector(id);
          })
          .catch(() => {
            // 用户取消
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
    },
    // 查询检测员
    async searchInspectors() {
      const queryParams = {
        ...this.searchParams,
        current: this.pageParams.current,
        pageSize: this.pageParams.pageSize,
      };
      try {
        const response = await fetchInspectors(queryParams);
        if (response.code === 200) {
          this.inspectors = response.data.records;
          this.pageParams.total = response.data.total;
        }
      } catch (error) {
        console.error("查询失败：", error);
      }
    },
    // 删除检测员
    async deleteInspector(id) {
      try {
        await deleteInspector(id);
        this.searchInspectors();
      } catch (error) {
        console.error("删除失败：", error);
      }
    },
    // 显示新增对话框
    showCreateDialog() {
      this.dialogMode = "create";
      this.formData = {
        id: null,
        nickName: "",
        phone: "",
        password: "",
        rePassword: "",
        permission: 2,
        adminId: this.permission === 0 ? null : this.currentAdminId, // 超级管理员可设置，普通管理员固定
      };
      this.dialogVisible = true;
    },
    // 显示编辑对话框
    showEditDialog(inspector) {
      this.dialogMode = "edit";
      this.formData = { ...inspector };
      this.dialogVisible = true;
    },
    // 提交表单
    async handleSubmit() {
      try {
        this.$refs.formRef.validate(async (valid) => {
          if (!valid) return; // 如果校验失败则不提交
          if (this.dialogMode === "create") {
            // 如果是普通管理员，强制设置 adminId 为自己的 ID
            if (this.permission === 1) {
              this.formData.adminId = this.currentAdminId;
            }
            await createInspector(this.formData);
          } else {
            await updateInspector(this.formData);
          }
          this.dialogVisible = false;
          this.searchInspectors(); // 刷新列表
        });
      } catch (error) {
        console.error("操作失败：", error);
      }
    },
  },

  created() {
    // 从 localStorage 获取权限和当前用户的 adminId
    const permission = JSON.parse(localStorage.getItem("permission"));
    if (permission != null) {
      this.permission = permission;
    } else {
      // 如果没有登录信息，跳转到登录页面
      this.$router.push("/login");
    }

    // 初始化查询
    this.searchInspectors();
  },
};
</script>

<style scoped>
.search-bar {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
